import React from 'react'
import {
  Routes,
  Route,
  Link,
  useRouteMatch,
  Navigate,
} from "react-router-dom";
import DashboardPage from '../pages/dashboard';
import ReportsPage from '../pages/reports/index.tsx';
import BuildingViewPage from '../pages/buildingView/index.js';

const DashboardRoutes = () => {
  return (
    <>
      <Routes>
        <Route path='' exact element={<Navigate to={'main/'} />} />
        <Route path='main/' exact element={<DashboardPage />} />
        <Route path='building/' exact element={<BuildingViewPage />} />
        <Route path='report/' exact element={<ReportsPage />} />
      </Routes>

    </>
  )
}
export default DashboardRoutes;
